var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9.1_Customer_06.1",
    transform: "translate(-1340.000000, -209.000000)",
    fill: "#8F9BA9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(260.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location-Copy",
    transform: "translate(760.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326,9 L324,9 L324,11 L326,11 L326,9 L326,9 Z M330,9 L328,9 L328,11 L330,11 L330,9 L330,9 Z M334,9 L332,9 L332,11 L334,11 L334,9 L334,9 Z M336,2 L335,2 L335,0 L333,0 L333,2 L325,2 L325,0 L323,0 L323,2 L322,2 C320.89,2 320.01,2.9 320.01,4 L320,18 C320,19.1 320.89,20 322,20 L336,20 C337.1,20 338,19.1 338,18 L338,4 C338,2.9 337.1,2 336,2 L336,2 Z M336,18 L322,18 L322,7 L336,7 L336,18 L336,18 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.09670465d9c52cd0ac2917c6ca4c92c2.svg";
export { ForwardRef as ReactComponent };